module.exports = __webpack_public_path__ + "static/media/icon-cancel.3f2737fd.svg";